{
    "name": "finstein-beratungsprozess",
    "version": "5.0.1",
    "scripts": {
        "ng": "ng",
        "generate:version-file": "npx ts-node scripts/generate-version-file.ts",
        "prestart": "npm run generate:version-file",
        "prebuild": "npm run generate:version-file",
        "start": "ng serve --port 4202",
        "start:test": "ng serve --port 4202 --configuration=test",
        "start-local": "ng serve --configuration=emulator",
        "build": "ng build --configuration $ENVIRONMENT",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "lint": "eslint src/**/*.ts"
    },
    "private": true,
    "dependencies": {
        "@angular-material-extensions/password-strength": "^16.0.0",
        "@angular/animations": "^18.2.0",
        "@angular/cdk": "18.2.6",
        "@angular/common": "^18.2.0",
        "@angular/compiler": "^18.2.0",
        "@angular/core": "^18.2.0",
        "@angular/fire": "^18.0.1",
        "@angular/forms": "^18.2.0",
        "@angular/material": "18.2.6",
        "@angular/platform-browser": "^18.2.0",
        "@angular/platform-browser-dynamic": "^18.2.0",
        "@angular/platform-server": "^18.2.0",
        "@angular/router": "^18.2.0",
        "@angular/service-worker": "^18.2.0",
        "@angular/ssr": "^18.2.5",
        "@auth0/angular-jwt": "^5.1.2",
        "@daelmaak/ngx-gallery": "^3.0.0",
        "@ng-bootstrap/ng-bootstrap": "^17.0.1",
        "@ng-select/ng-option-highlight": "^13.8.1",
        "@ng-select/ng-select": "^13.8.1",
        "@ngneat/until-destroy": "^10.0.0",
        "@ngx-translate/core": "^15.0.0",
        "@ngx-translate/http-loader": "^8.0.0",
        "@popperjs/core": "^2.11.8",
        "@rxweb/reactive-form-validators": "^13.0.1",
        "@sweetalert2/ngx-sweetalert2": "^12.4.0",
        "@swimlane/ngx-datatable": "20.1.0",
        "@uiowa/digit-only": "^3.2.1",
        "angular2-uuid": "^1.1.1",
        "animejs": "^3.2.1",
        "bootstrap": "^4.5.0",
        "cliui": "^8.0.1",
        "crypto-js": "^4.1.1",
        "express": "^4.18.2",
        "fireworks-js": "^2.10.7",
        "font-awesome": "^4.7.0",
        "hammerjs": "^2.0.8",
        "inputmask": "^5.0.9",
        "jquery": "^3.7.1",
        "libphonenumber-js": "^1.10.43",
        "lodash": "^4.17.21",
        "moment": "^2.30.1",
        "ng-circle-progress": "^1.7.1",
        "ng-recaptcha": "^13.2.1",
        "ng2-currency-mask": "^13.0.3",
        "ng2-pdf-viewer": "^10.0.0",
        "ngx-cookie-service": "^18.0.0",
        "ngx-gallery-9": "^1.0.6",
        "ngx-mask": "^14.0.0",
        "ngx-scrollbar": "^13.0.3",
        "ngx-spinner": "^16.0.2",
        "ngx-toastr": "^19.0.0",
        "ngx-ui-switch": "^14.0.3",
        "rxjs": "~7.8.0",
        "sweetalert2": "^11.14.5",
        "t-writer.js": "^1.0.4",
        "ts-node": "^10.9.2",
        "tslib": "^2.3.0",
        "wrap-ansi": "^9.0.0",
        "zone.js": "~0.14.10"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^18.2.5",
        "@angular-eslint/builder": "18.4.0",
        "@angular-eslint/eslint-plugin": "18.4.0",
        "@angular-eslint/eslint-plugin-template": "18.4.0",
        "@angular-eslint/schematics": "18.4.0",
        "@angular-eslint/template-parser": "18.4.0",
        "@angular/cli": "^18.2.5",
        "@angular/compiler-cli": "^18.2.0",
        "@types/animejs": "^3.1.12",
        "@types/crypto-js": "^4.2.2",
        "@types/express": "^4.17.17",
        "@types/hammerjs": "^2.0.46",
        "@types/inputmask": "^5.0.7",
        "@types/jasmine": "~5.1.0",
        "@types/lodash": "^4.17.9",
        "@types/node": "^18.18.0",
        "@types/ua-parser-js": "^0.7.39",
        "@typescript-eslint/eslint-plugin": "8.14.0",
        "@typescript-eslint/parser": "^8.14.0",
        "eslint": "^9.14.0",
        "jasmine-core": "~5.2.0",
        "karma": "~6.4.0",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.0",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "typescript": "~5.5.2"
    }
}
